import React from 'react';
import { useSelector } from 'react-redux';

import {
  StockItem,
  StockItemFormat,
  StockItemContext,
} from '../../../../../common/types/StockItemTypes';
import { selectIsPolling } from '../../../../ContentEdit/ContentEditSlice';
import { selectShowAnimatedAiThumbnailButton } from '../../../selectors/searchSelectors';
import {
  AIEditButton,
  DownloadButton,
  FavoriteButton,
  MakerButton,
  RelatedVideosButtonContainer,
} from './Buttons';

export type ActionButtonsProps = {
  containPoppers: boolean;
  context: StockItemContext;
  downloadButtonTelemetryAction: () => void;
  favoriteButtonTelemetryAction: () => void;
  getPrimaryClickAction: () => (
    event?: React.MouseEvent
  ) => void | Promise<void>;
  handleAIEditAction: () => void;
  handleClickAction: (e: MouseEvent) => void;
  isHovering: boolean;
  makerButtonTelemetryAction: () => void;
  openFoldersInNewWindow: boolean;
  shouldShowAIEditButton: boolean;
  shouldShowDownloadButton: boolean;
  shouldShowMakerButton: boolean;
  similarContentAction: () => void;
  stockItem: StockItem;
  stockItemFormats: StockItemFormat[];
};

export default function StockItemActions({
  context,
  containPoppers,
  downloadButtonTelemetryAction,
  favoriteButtonTelemetryAction,
  getPrimaryClickAction,
  handleAIEditAction,
  handleClickAction,
  isHovering,
  makerButtonTelemetryAction,
  openFoldersInNewWindow,
  shouldShowAIEditButton,
  shouldShowMakerButton,
  shouldShowDownloadButton,
  similarContentAction,
  stockItem,
  stockItemFormats,
}: ActionButtonsProps) {
  if (!isHovering) {
    return null;
  }
  const showAnimatedAiThumbnailButton = useSelector(
    selectShowAnimatedAiThumbnailButton
  );
  const isContentEditPolling = useSelector(selectIsPolling);

  return (
    <div
      className="absolute flex items-center justify-between w-full left-0 bottom-0 px-4 pb-4 space-x-2"
      data-testid="action-buttons"
    >
      <div className="flex space-x-2">
        {showAnimatedAiThumbnailButton ? (
          <>
            {shouldShowAIEditButton && (
              <AIEditButton
                onClick={handleAIEditAction}
                disabled={isContentEditPolling}
              />
            )}
            {context === StockItemContext.SEARCH && (
              <RelatedVideosButtonContainer
                stockItem={stockItem}
                onClick={similarContentAction}
              />
            )}
          </>
        ) : (
          <>
            {context === StockItemContext.SEARCH && (
              <RelatedVideosButtonContainer
                stockItem={stockItem}
                onClick={similarContentAction}
              />
            )}
            {shouldShowAIEditButton && (
              <AIEditButton
                onClick={handleAIEditAction}
                disabled={isContentEditPolling}
              />
            )}
          </>
        )}
        <FavoriteButton
          containPoppers={containPoppers}
          stockItem={stockItem}
          stockItemFormats={stockItemFormats}
          favoriteButtonTelemetryAction={favoriteButtonTelemetryAction}
          openFoldersInNewWindow={openFoldersInNewWindow}
          onClick={handleClickAction}
          context={context}
          thumbnailExperiment
        />
        {shouldShowMakerButton && !showAnimatedAiThumbnailButton && (
          <MakerButton
            stockItem={stockItem}
            makerButtonTelemetryAction={makerButtonTelemetryAction}
            thumbnailExperiment
          />
        )}
      </div>
      <DownloadButton
        shouldShowDownloadButton={shouldShowDownloadButton}
        downloadButtonTelemetryAction={downloadButtonTelemetryAction}
        onClick={getPrimaryClickAction()}
        thumbnailExperiment
      />
    </div>
  );
}
